import * as api from "../2- api/index";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
var favoriteSource;
var browseSource;
var specialSource;
var soonSource;
var recentSource;
var novelSource;
var suggestSource;
var paginationSource;
var userSource;
var userDetailsSource;

export const getSpecialForYou = createAsyncThunk(
  "getSpecialForYou",
  async () => {
    if (specialSource) {
      specialSource.cancel();
    }
    const CancelToken = axios.CancelToken;
    specialSource = CancelToken.source();
    const { data } = await api.fetchSpecialForYou(specialSource);
    return data;
  }
);
export const getComingSoonNovel = createAsyncThunk(
  "getComingSoonNovel",
  async () => {
    if (soonSource) {
      soonSource.cancel();
    }
    const CancelToken = axios.CancelToken;
    soonSource = CancelToken.source();
    const { data } = await api.fetchComingSoon(soonSource);
    return data;
  }
);
export const getRecentNovel = createAsyncThunk("getRecentNovel", async () => {
  if (recentSource) {
    recentSource.cancel();
  }
  const CancelToken = axios.CancelToken;
  recentSource = CancelToken.source();
  const { data } = await api.fetchRecentNovel(recentSource);
  return data;
});
// chapters
export const getChapters = createAsyncThunk(
  "getChaps/retrieve",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.fetchChapters(id);
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const getNovelsChaps = createAsyncThunk(
  "getNovelChaps/retrieve",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.fetchChapter(id);
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const createNovelsChaps = createAsyncThunk(
  "createNovelsChaps/create",
  async (newNovel, { rejectWithValue }) => {
    try {
      const { data } = await api.createNovelChaps(newNovel);
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const updateNovelsChaps = createAsyncThunk(
  "updateNovelsChaps/update",
  // userData is coming from the component
  async (userData, { rejectWithValue }) => {
    try {
      const { data } = await api.updateNovelChaps(
        userData.userId,
        userData.obj
      );
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const deleteNovelsChaps = createAsyncThunk(
  "deleteNovels/delete",
  async (id, { rejectWithValue }) => {
    try {
      await api.deleteNovelChaps(id);
      return id;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const deleteNovelsChapsAll = createAsyncThunk(
  "deleteNovelsAll/delete",
  async (id, { rejectWithValue }) => {
    try {
      await api.deleteNovelChapsAll(id);
      return id;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);

export const getNovel = createAsyncThunk(
  "getNovel",
  async (id, { rejectWithValue }) => {
    try {
      if (novelSource) {
        novelSource.cancel();
      }
      const CancelToken = axios.CancelToken;
      novelSource = CancelToken.source();

      const { data } = await api.fetchNovel(id, novelSource);
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const updateCurrentNovel = createAsyncThunk(
  "updateCurrentNovel",
  async (updateCurrentNovel, { rejectWithValue }) => {
    try {
      const { data } = await api.UpdateCurrentNovel(
        updateCurrentNovel.userId,
        updateCurrentNovel.obj
      );
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const getLatestNovelComments = createAsyncThunk(
  "getLatestNovelComments",
  async (object, { rejectWithValue }) => {
    try {
      const { data } = await api.fetchLatestUserNovels(object);
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const getSuggestionsNovels = createAsyncThunk(
  "getSuggestionsNovels",
  async (Suggestedtags, { rejectWithValue }) => {
    try {
      if (suggestSource) {
        suggestSource.cancel();
      }
      const CancelToken = axios.CancelToken;
      suggestSource = CancelToken.source();

      const { data } = await api.fetchSuggestionsNovels(
        Suggestedtags,
        suggestSource
      );
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const getFavoriteNovel = createAsyncThunk(
  "getFavoriteNovel",
  async (favoriteNovels, { rejectWithValue }) => {
    try {
      if (favoriteSource) {
        favoriteSource.cancel();
      }
      const CancelToken = axios.CancelToken;
      favoriteSource = CancelToken.source();

      const { data } = await api.fetchFavoriteNovel(favoriteNovels);
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const getNovelsPagination = createAsyncThunk(
  "getNovels/Pagination",
  async (searchQuery, { rejectWithValue }) => {
    try {
      if (paginationSource) {
        paginationSource.cancel();
      }
      const CancelToken = axios.CancelToken;
      paginationSource = CancelToken.source();

      const { data } = await api.fetchNovelsPagination(
        searchQuery,
        paginationSource
      );
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);

export const getBrowsingNovel = createAsyncThunk(
  "getBrowsingNovel/InfiniteScrolling",
  async (idXsearchQuery, { rejectWithValue }) => {
    try {
      if (browseSource) {
        browseSource.cancel();
      }
      const CancelToken = axios.CancelToken;
      browseSource = CancelToken.source();

      const { data } = await api.fetchNovelsPagination(
        idXsearchQuery,
        browseSource
      );
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);

export const getUserNovel = createAsyncThunk(
  "getUserNovel",
  async (id, { rejectWithValue }) => {
    try {
      if (userSource) {
        userSource.cancel();
      }
      const CancelToken = axios.CancelToken;
      userSource = CancelToken.source();

      const { data } = await api.fetchUserNovelsCRUD(id, userSource);
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const getUserDetail = createAsyncThunk(
  "getUserDetail",
  async (id, { rejectWithValue }) => {
    try {
      if (userDetailsSource) {
        userDetailsSource.cancel();
      }
      const CancelToken = axios.CancelToken;
      userDetailsSource = CancelToken.source();

      const { data } = await api.fetchUserNovelsCRUD(id, userDetailsSource);
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);

export const createNovels = createAsyncThunk(
  "createNovel/create",
  async (newNovel, { rejectWithValue }) => {
    try {
      const { data } = await api.createNovel(newNovel);
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const updateNovels = createAsyncThunk(
  "updateNovels/update",
  // userData is coming from the component
  async (userData, { rejectWithValue }) => {
    try {
      const { data } = await api.updateNovel(userData.userId, userData.obj);
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const deleteNovels = createAsyncThunk(
  "deleteNovels/delete",
  async (id, { rejectWithValue }) => {
    try {
      await api.deleteNovel(id);
      return id;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
